"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    cardFooterClassNames: function() {
        return cardFooterClassNames;
    },
    useCardFooterStyles_unstable: function() {
        return useCardFooterStyles_unstable;
    }
});
const _react = require("@griffel/react");
const cardFooterClassNames = {
    root: 'fui-CardFooter',
    action: 'fui-CardFooter__action'
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f22iagw",
        Beiy3e4: "f1063pyq",
        i8kkvl: "f4akndk",
        Belr9w4: "fe5j3v"
    },
    action: {
        Frg6f3: [
            "fcgxt0o",
            "f1ujusj6"
        ]
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f1063pyq{flex-direction:row;}",
        ".f4akndk{column-gap:12px;}",
        ".fe5j3v{row-gap:12px;}",
        ".fcgxt0o{margin-left:auto;}",
        ".f1ujusj6{margin-right:auto;}"
    ]
});
const useCardFooterStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(cardFooterClassNames.root, styles.root, state.root.className);
    if (state.action) {
        state.action.className = (0, _react.mergeClasses)(cardFooterClassNames.action, styles.action, state.action.className);
    }
    return state;
}; //# sourceMappingURL=useCardFooterStyles.styles.js.map
